import { reactive } from "vue"

const State = reactive({
	menu: {
		open: false,
	}
})

export const openMenu   = () => State.menu.open = true
export const closeMenu  = () => State.menu.open = false
export const toggleMenu = () => State.menu.open = !State.menu.open

export default State
